import React from "react";
import TableNumberBaseNull3 from "../TableNumberBaseNull3";
import "./TableTextBaseNull3.css";

function TableTextBaseNull3(props) {
  const { tableNumberBaseNull3Props } = props;

  return (
    <div className="table-text-base-null-6">
      <TableNumberBaseNull3 tableNumberBase8Props={tableNumberBaseNull3Props.tableNumberBase8Props} />
    </div>
  );
}

export default TableTextBaseNull3;
